/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'external': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.125 20.5V2.75a4.096 4.096 0 014.096 4.096v9.558h9.558a4.096 4.096 0 014.096 4.096H3.125zM17.55 5.115h-4.412v-2h6.827a1 1 0 011 1v6.827h-2V6.53l-8.306 8.305-1.414-1.414 8.306-8.306z" _fill="#EF7812"/>'
  }
})
